<template>
    <div>
        <button class="mb-2 mx-0 btn btn-primary w-100" type="button" @click="collapsed = !collapsed" v-b-toggle="'collapseAnswer' + questionId">
            Answer <icon icon="chevron-up" :class="{'rotate' : collapsed}"></icon>
        </button>
        <b-collapse :id="`collapseAnswer${questionId}`">
            <draggable
            tag="ul"
            class="list-group mb-3"
            v-model="answers"
            v-bind="dragOptions"
            @start="isDragging = true"
            @end="isDragging = false"
            @change="dragMove"
            handle=".handle">
                <li class="draggable-item mb-2" v-for="(answer, index) in answers" :key="questionId+index+'answer'">
                    <div class="card">
                        <div class="card-header handle d-flex p-1">
                            <icon icon="arrows-alt-v" class="handle my-auto"></icon>
                            <span class="my-auto ml-1">Answer {{answer.order}}</span>
                            <input class="form-control ml-3" v-model="answer.answerText" placeholder="Answer" />
                            <div class="form-check my-auto ml-3">
                                <input class="form-check-input" type="checkbox" v-model="answer.isCorrect" value="" id="typeCheck">
                                <label class="form-check-label" for="typeCheck">Is Correct</label>
                            </div>
                            <input class="form-control ml-3" v-model="answer.score" type="number" placeholder="Score">
                            <button type="button" class="btn btn-danger btn-delete-answer" @click="deleteAnswer(index)">Delete Answer</button>
                        </div>
                    </div>
                </li>
            </draggable>
            <button type="button" class="btn btn-primary" @click="addAnswer"><icon icon="plus-circle" /> Add answer</button>
        </b-collapse>
    </div>
</template>

<script>import draggable from 'vuedraggable'
    export default {
        data() {
            return {
                answers: [],
                collapsed: true
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost",
                    group: {
                        put: false,
                        pull: false
                    }
                }
            }
        },
        props: {
            questionId: String,
            save: Boolean,
            saved: Boolean
        },
        components: {
            draggable
        },
        methods: {
            addAnswer: function () {
                let emptyAnswer = {
                    answerText: "",
                    answerTextTranslationKey: "",
                    score: 0,
                    isCorrect: false,
                    questionId: this.questionId,
                    order: this.answers.length + 1
                }
                this.answers.push(emptyAnswer)
                _.orderBy(this.answers, 'order')
                this.$emit('answersChanged', this.answers, this.questionId)
            },
            deleteAnswer: function (index) {
                let id = this.answers[index].id
                if (id) {
                    this.$http.delete(`/api/questionnaires/answer/delete/${id}`)
                        .then(response => {
                            console.log('deleted')
                            this.answers.splice(index, 1)
                            this.$emit('answersChanged', this.answers, this.questionId)
                        })
                        .catch(error => {
                            console.log(error)
                        })
                }
                else {
                    this.answers.splice(index, 1)
                    this.$emit('answersChanged', this.answers, this.questionId)
                }
            },
            loadAnswers: function () {
                let self = this
                this.$http.get(`/api/questionnaires/question/${this.questionId}/answers`)
                    .then(response => {
                        self.answers = response.data;
                        self.answers = _.orderBy(self.answers, 'order');
                        self.normalizeAnswersOrder();
                        this.$emit('answersChanged', this.answers, this.questionId);
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            dragMove: function (evt) {
                this.answers.forEach((element, index) => {
                    element.order = index + 1
                });
            },
            normalizeAnswersOrder() {
                for (let i = 0; i < this.answers.length; i++) {
                    this.answers[i].order = i + 1;
                }
            }
        },
        mounted: function () {
            this.loadAnswers()
        },
        watch: {
            save(value) {
                if (value === true) {
                    this.$emit('answersChanged', this.answers, this.questionId)
                }
            },
            saved(value) {
                if (value === true) {
                    this.loadAnswers()
                }
            }
        }
    }</script>

<style lang="scss" scoped>
    .collapse {
        transition: 1s;
    }
    svg {
        &[data-icon="chevron-up"]{
            transition: 0.5s;
            &.rotate{
                transition: 0.5s;
                transform: rotate(180deg);
            }
        }
    }
    .card-body {
        padding-top: 0.3rem !important;
        padding-left: 0.3rem !important;
    }
    .flip-list-move {
    transition: transform 1s;
    }
    .no-move {
    transition: transform 0s;
    }
    .ghost {
    opacity: 0.5;
    background: #c8ebfb;
    }
    .list-group {
    min-height: 20px;
    }
    .draggable-item {
        .card-header{
            cursor: move
        }
    }
    .draggable-item{
        icon {
            cursor: pointer;
        }
    }
    ul {
        list-style-type: none;
    }

    .btn-delete-answer {
        position: absolute;
        right: 12px;
        top: 8px;
    }
</style>

